__turbopack_context__.v({
  "bullet": "UspsFun-module-scss-module__f6Az9a__bullet",
  "bullet-wrapper": "UspsFun-module-scss-module__f6Az9a__bullet-wrapper",
  "extras": "UspsFun-module-scss-module__f6Az9a__extras",
});
